import * as React from 'react';

function link() {
  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = 'https://cdn-prod.securiti.ai/consent/cookie-consent.css';
  return link;
}

function script(_a) {
  var uuidDomain = _a.uuidDomain,
      onLoad = _a.onLoad;
  var attrs = {
    'data-domain-uuid': uuidDomain,
    'data-backend-url': 'https://app.securiti.ai',
    'data-tenant-uuid': '9d5dc0ff-382a-4fbf-b754-bd6123844ee0'
  };
  var script = document.createElement('script');
  script.defer = true;
  script.src = 'https://cdn-prod.securiti.ai/consent/cookie-consent-sdk.js';
  Object.entries(attrs).forEach(function (_a) {
    var prop = _a[0],
        value = _a[1];
    return script.setAttribute(prop, value);
  });

  script.onload = function () {
    var _a;

    (_a = window['initCmp']) === null || _a === void 0 ? void 0 : _a.call(window);
    onLoad();
  };

  return script;
}

function append(element) {
  (document.head || document.body).appendChild(element);
}

function scriptExists(uuidDomain) {
  return !!document.querySelector("[data-domain-uuid=\"" + uuidDomain + "\"]");
}

function registerCustomer(uuidCustomer) {
  var _a;

  if (uuidCustomer) {
    (_a = window['setConsentBannerParams']) === null || _a === void 0 ? void 0 : _a.call(window, {
      uuid: uuidCustomer
    });
  }
}

function useCookieConsentInjection(uuidDomain, uuidCustomer) {
  var _a = React.useState(false),
      injected = _a[0],
      setInjected = _a[1];

  React.useEffect(function () {
    if (injected || !uuidDomain) {
      return;
    }

    if (scriptExists(uuidDomain)) {
      setInjected(true);
      return;
    }

    append(link());
    append(script({
      uuidDomain: uuidDomain,
      onLoad: function onLoad() {
        setInjected(true);
        registerCustomer(uuidCustomer);
      }
    }));
  }, [injected, uuidDomain, uuidCustomer]);
  React.useEffect(function () {
    if (injected) {
      registerCustomer(uuidCustomer);
    }
  }, [injected, uuidCustomer]);
  return {
    injected: injected
  };
}

var SebraeCookieConsent = function SebraeCookieConsent(_a) {
  var _b = _a.uuidApp,
      uuidApp = _b === void 0 ? '' : _b,
      _c = _a.uuidUser,
      uuidUser = _c === void 0 ? '' : _c,
      _d = _a.debug,
      debug = _d === void 0 ? false : _d;
  var uuidDomain = React.useMemo(function () {
    return uuidApp !== null && uuidApp !== void 0 ? uuidApp : '';
  }, [uuidApp]);
  var uuidCustomer = React.useMemo(function () {
    return uuidUser !== null && uuidUser !== void 0 ? uuidUser : '';
  }, [uuidUser]);
  var injected = useCookieConsentInjection(uuidDomain, uuidCustomer).injected;
  React.useEffect(function () {
    if (debug) {
      if (uuidApp) {
        return console.log(injected ? '[Sebrae Cookie Consent :: %s] Opa! Já injetou o CSS e o JS' : '[Sebrae Cookie Consent :: %s] Não injetou o CSS e o JS ainda', uuidApp);
      }

      console.log('[Sebrae Cookie Consent] Sem UUID da aplicação');
    }
  }, [debug, uuidApp, injected]);
  React.useEffect(function () {
    if (debug) {
      if (uuidUser) {
        return console.log(injected ? '[Sebrae Cookie Consent :: %s] Opa! Já registrou o usuário' : '[Sebrae Cookie Consent :: %s] Não registrou o usuário ainda', uuidUser);
      }

      console.log('[Sebrae Cookie Consent] Sem UUID do usuário');
    }
  }, [debug, uuidUser, injected]);
  return React.createElement(React.Fragment, null);
};

export { SebraeCookieConsent };